import Vue from 'vue'
import { get, post } from './apiAxios'

const vue = new Vue()
// GET请求,将url和请求参数传入，通过Promise，将成功和失败的数据派发出去
export function getHttp (url, params) {
    console.log('%c接口请求参数----------->' + url, 'background: blue; color: #fff')
    console.log('request--------->',url,'params----->', params)
    return get(url, params)
    // return new Promise((resolve, reject) => {
    //     vue.$http.get(url, {
    //         params: params
    //     }).then(response => {
    //         console.log('%c接口返回参数参数----------->' + url, 'background: green; color: #fff')
    //         console.log('response--------->', response)
    //         resolve(response)
    //     }, response => {
    //         reject(response.bodyText)
    //     })
    // })
}

// POST请求，将url,请求参数和body传入，通过Promise，将成功和失败的数据派发出去
export function postHttp (url, params, body) {
    console.log('%c接口请求参数----------->' + url, 'background: blue; color: #fff')
    console.log('request--------->', params)
    // const token = getToken()
    return post(url, params)
    // return new Promise((resolve, reject) => {
    //     // vue.$http.headers.post['Tenant-Id'] = 690547
    //     vue.$http.post(url, {
    //         params: params
    //     }).then(response => {
    //         // console.log('%c接口返回参数参数----------->' + url, 'background: green; color: #fff')
    //         // console.log('response--------->', response)
    //         resolve(response)
    //     }, response => {
    //         reject(response.bodyText)
    //     })
    // })
}
// 登录方法
export function login (url, params, body) {
    console.log('login接口:' + url + '请求参数------->', params)
    // const token = getToken()
    return new Promise((resolve, reject) => {
        vue.$http.post(url, params).then(response => {
            resolve(response)
        }, response => {
            reject(response.bodyText)
        })
    })
}
// 封装post请求方法,传入 url,raw,回调(success,errorMsg,data)
export function postHttpForData (url, params) {
    console.log('接口:' + url + '请求参数------->', params)
    return new Promise((resolve, reject) => {
        vue.$http.post(url, params)
            .then(response => {
                // 判断是否成功
                if (response == null || response.body == null) {
                    resolve(false, '请求失败', null)
                    return
                }

                resolve(response.body.success, response.body.error.errorMessage, response.body.data)
            }, response => {
                reject(response.bodyText)
            })
    })
}

// 封装post请求列表方法,传入 url,raw,回调(total,list)
export function postHttpForList (url, params) {
    console.log('接口:' + url + '请求参数------->', params)
    // const token = getToken()
    return new Promise((resolve, reject) => {
        vue.$http.post(url, params)
            .then(response => {
                // 判断是否成功
                var result = {}
                if (response == null || response.body == null || response.body.data == null) {
                    result.total = 0
                    result.list = []
                    resolve(result)
                    return
                }
                console.log('返回结果:', response)
                const data = response.body.data
                console.log('返回data:', data)
                result.total = data.total
                result.list = data.list
                resolve(result)
            }, response => {
                reject(response.bodyText)
            })
    })
}



// WEBPACK FOOTER //
// ./src/utils/vueresource.js